import { render, staticRenderFns } from "./StunServers.vue?vue&type=template&id=655f88a2&"
import script from "./StunServers.vue?vue&type=script&lang=js&"
export * from "./StunServers.vue?vue&type=script&lang=js&"
import style0 from "./StunServers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports